import { Box, Grid, Typography } from "@mui/material"
import { ThreeDots } from "../modal/ThreeDots";
import { FileInfo } from "../modal/FileInfo";
import { useState } from "react";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

export const TBody = ({ teamData, handleOpenMember, handleUpdate, handleOpen,allUsers}) => {
    const [open, setOpen] = useState(false)
    const [selectId, setSelectId] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const handleMOpen =()=>{
        setOpen(true);
        setIsLoading(true)
        const timer = setTimeout(() => setIsLoading(false), 2000);
            return () => clearTimeout(timer);
    }
        
    return (
        <Box height="100%" width="100%" gap="12px" className="overflowY" display="flex" flexDirection="column"  >
            {
                teamData.data.map((v,k) => (
                    <Box key={k} width="100%"  fontWeight={400} display="block"  border="1px solid #EBEBEB"  bgcolor="#FFFFFF"   p='15px 0px 8px 20px'>
                        <Grid container display='flex' >
                            <Grid item xs={10} onClick={(e)=>{e.stopPropagation();setSelectId(v);handleMOpen()}}  >
                               {/*    */}
                                <Box display={'row'} justifyContent={'space-between'} >
                                    <Box  sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Box sx={{height:'auto', fontSize:'12px', color:"#11783C"}}>{v.team_number}</Box>
                                        <Box sx={{height:'auto', fontSize:'12px',textAlign:'center'}}   bgcolor={v.active === 1 ? '#00be811f' : '#E4E5E6'} color={v.active === 1 ? '#00be81' : '#7B7F82'} borderRadius="16px" px={1}>
                                            <Box>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                                        </Box>
                                    </Box>

                                    <Box  sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Typography sx={{ fontSize:'14px'}} fontWeight={500}>Team Name: </Typography>
                                        <Box sx={{ fontSize:'14px',textAlign:'right'}}>{v.name}</Box>
                                    </Box>

                                    <Box  sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Typography sx={{ fontSize:'14px'}} fontWeight={500}>Team Member: </Typography>
                                        <Box sx={{ fontSize:'14px',textAlign:'right'}}>
                                            <Box className="c-pointer"  onClick={(e) => {e.stopPropagation();handleOpenMember (e, v)}}>
                                                <AvatarGroup max={3} spacing={3} sx={{'& .MuiAvatar-root': { width: 20, height: 20, fontSize: 12, },}}>
                                                    {allUsers?.filter(user => v.member?.includes(user.id)).map(user => (
                                                        <Avatar
                                                            key={user.id}
                                                            alt={user.uname}
                                                            src={user.profile}>
                                                            {!user.profile && user.uname?.[0]}
                                                            {/* {user.profile} */}
                                                        </Avatar>
                                                    ))}
                                                </AvatarGroup>
                                            </Box>
                                        
                                        </Box>
                                    </Box>
                                </Box>
                                
                            </Grid>
                                <Grid item xs={2}>
                                    <Box display='flex' justifyContent="center" alignItems='center' height='100%'>
                                    <ThreeDots handleOpenMember={handleOpenMember}  handleUpdate={handleUpdate} v={v} handleMOpen={handleMOpen} allUsers={allUsers} isLoading={isLoading} />
                                    </Box>
                                
                                </Grid>
                        </Grid>
                        <FileInfo open={open} onClose={()=> setOpen(false)} v={selectId} allUsers={allUsers}  handleOpenMember={handleOpenMember} isLoading={isLoading}/>
                    </Box>

                ))
            }

            
        </Box>
    )
}